<template>
  <!-- <b-container class="card-container"> -->
    <b-card>
      <template v-slot:header class="card-menu">
        <span class="breadcrumbs"><b-link :to="{name: `sequence`}">{{collection | capitalise | pluralise}}</b-link> / {{item ? item.email : ''}}</span>
        <!-- <b-button size="sm" variant="primary float-right" :to="{name: `${collection}_edit`}">Edit</b-button> -->

        <b-button size="sm" variant="secondary float-right" @click="queue_task_now" :disabled="!item || item.task_status !== 'pending'" v-if='item && item.status === "active"'>Do next step now</b-button>
        <b-button v-if="profile.role === 'admin' && item && (item.status === 'active' || item.status === 'pending')" size="sm" variant="secondary float-right mr-2" @click="update_status('finished')">Mark Finished</b-button>
        <b-button v-if="profile.role === 'admin' && item && (item.status === 'active' || item.status === 'pending')" size="sm" variant="secondary float-right mr-2" @click="update_status('replied')">Mark Replied</b-button>
        <b-button v-if="profile.role === 'admin'" size="sm" class="float-right mr-2" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fsequence~2F${$route.params.id}~2Frecipient~2F${$route.params.recipient}`" target="_blank"><i class="fas fa-database"></i></b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>

        <b-alert :show="item.status === 'error'" variant='warning'>
          An error has occured, we are looking into this and will let you know once it is resolved.
        </b-alert>
        <b-alert :show="item.status === 'finished'" variant='success'>
          This recipient has finished the sequence.
        </b-alert>
        <b-alert :show="item.status === 'pending'" variant='info'>
          This recipient is pending processing. Please check back in a few minutes.
        </b-alert>
        <b-alert :show="item.status === 'active'" variant='info'>
          This lead at step <span v-if="item.next_step && steps_by_id[item.next_step.id] !== undefined">{{steps_by_id[item.next_step.id].index + 1}} of {{sequence.steps.length}}</span>. The next step will happen at {{item.next_step_date | datetime}}
        </b-alert>
        <b-alert :show="item.status === 'replied'" variant='success'>
          This recipient has replied. They have finished the sequence.
        </b-alert>
        <b-alert :show="item.status === 'bounced'" variant='warning'>
          This recipient has bounced. They have finished the sequence.
        </b-alert>
        <b-alert :show="item.status === 'unsubscribed'" variant='warning'>
          This recipient has unsubscribed. They have finished the sequence.
        </b-alert>
        <b-alert :show="item.status === 'auto_replied'" variant='warning'>
          This recipient has replied automatically e.g. out of office. They have finished the sequence.
        </b-alert>

        <b-table-simple responsive bordered class="mt-2" size="sm">
          <b-tr>
            <b-td>Email</b-td>
            <b-td>{{item.email}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>First name</b-td>
            <b-td>{{item.first_name}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Last name</b-td>
            <b-td>{{item.last_name}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Organisation</b-td>
            <b-td>{{item.organisation}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Website URL</b-td>
            <b-td>{{item.website}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Custom 1</b-td>
            <b-td>{{item.custom_1}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Custom 2</b-td>
            <b-td>{{item.custom_2}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Custom 3</b-td>
            <b-td>{{item.custom_3}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Custom 4</b-td>
            <b-td>{{item.custom_4}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Timezone offset</b-td>
            <b-td>{{item.timezone_offset}}</b-td>
          </b-tr>
        </b-table-simple>

        <EmailSequence v-if='item_steps && item_steps[0] && item_steps[0].id' :key='item_steps.length' :recipient="item" :create="false" :sequence="sequence" :profile="profile" :steps="item_steps" :from_email="sequence.sender ? sequence.sender.email : ''"  style='max-width: 720px;'/>
<!--
        <div v-if="videos.length > 0">
          <h4>Videos</h4>
          <ul>
            <li v-for="video in videos" :key="video.id">{{video.ref.parent.id}}</li>
          </ul>
        </div> -->

        <p class="muted"><small>Created {{item.created | datetime}}<br>Updated {{item.updated | datetime}}</small></p>
      </div>
    </b-card>
  <!-- </b-container> -->
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import { db } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"
import EmailSequence from '@/components/EmailSequence'


export default {
  metaInfo: {title: 'Recipient'},
  mixins: [ItemMixin],
  props: ['profile', 'sequence'],
  components: {EmailSequence},
  firestore: function () {
    return {
      item: db.collection('sequence').doc(this.$route.params.id).collection(this.collection).doc(this.$route.params.recipient),
      item_steps: db.collection('sequence').doc(this.$route.params.id).collection(this.collection).doc(this.$route.params.recipient).collection('step').orderBy('created'),
      // videos: db.collectionGroup('item').where('recipient', '==', db.collection('sequence').doc(this.$route.params.id).collection(this.collection).doc(this.$route.params.recipient)).orderBy('created')
    }
  },
  data() {
    return {
      item_steps: [],
      // videos: [],
      collection: 'recipient'
    }
  },
  computed: {
    steps_by_id() {
      let steps_by_id = {}
      let i = 0
      for (let step of this.sequence.steps) {
        if (!step.id) {
          break
        }

        step.index = i
        // _step.index = i
        steps_by_id[step.id] = step

        i++
      }

      return steps_by_id
    }
  },
  watch: {
    item_steps: {
      deep: true,
      handler: function() {
        this.$forceUpdate()
      }
    }
  },
  methods: {
    update_status(status) {
      this.$firestoreRefs.item.update({updated: new Date(), status: status})
    },
    queue_task_now() {
      return this.$firestoreRefs.item.update({updated: new Date(), task_status: 'queued'})
    }
  }
}
</script>

<style>
.breadcrumbs {
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
  display: inline-block;
}


</style>
